import React, { useEffect } from 'react';
import { Input } from '@cokitchen/cokitchen-components';
import { DAYS } from 'utils/constants';
import useGetStartedActionsContext from 'contexts/get-started-actions.context';

const SetOperatingDays = () => {
  const { operatingDays, setOperatingDays, setIsDisabled } = useGetStartedActionsContext();

  const toggleDay = (index: number) => {
    const days = [...operatingDays.days];
    const newDay = days[index];
    newDay.is_active = !newDay.is_active;
    days[index] = newDay;
    setOperatingDays({ days });
  };

  useEffect(() => {
    setIsDisabled(!Object.values(operatingDays.days).some((d) => d.is_active));
  }, [operatingDays]);

  return (
    <div>
      <div className='max-w-[390px] flex flex-col gap-10'>
        <article className='flex flex-col gap-3'>
          <h3 className='text-[32px] leading-[41.6px] font-semibold'>Set office operating days</h3>
          <p className='text-gray-9'>Select office opening and closing days</p>
        </article>
        <div className='rounded-sm border border-[#EFF0F0] px-4 py-3 '>
          <p className='text-sm font-medium  pb-4'>Select operating days</p>
          <div className=' grid grid-cols-3 gap-4'>
            {operatingDays.days?.map((day, index) =>
              [0, 6].includes(index) ? null : (
                <Input
                  key={index}
                  type='checkbox'
                  label={DAYS[index]}
                  checked={day.is_active}
                  onChange={() => toggleDay(index)}
                />
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetOperatingDays;
